// extracted by mini-css-extract-plugin
module.exports = {"modifyModal":"ProductArticle_modifyModal__28ZaU","modifyBottomModal":"ProductArticle_modifyBottomModal__1wi4F"};